import React from 'react';
import { motion } from 'framer-motion';
import {
	ArrowRight,
	CalendarCheck,
	MessageCircle,
	Sparkles,
} from 'lucide-react';

function Hero() {
	return (
		<section className='landing-hero'>
			<div className='landing-hero__copy'>
				<motion.p
					className='landing-eyebrow'
					initial={{ opacity: 0, y: 16 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.55 }}>
					AI commerce for neighborhood businesses
				</motion.p>
				<motion.h1
					initial={{ opacity: 0, y: 24 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.7, delay: 0.08 }}>
					Grow Your Business in Your Community
				</motion.h1>
				<motion.p
					className='landing-hero__subhead'
					initial={{ opacity: 0, y: 24 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.7, delay: 0.16 }}>
					Build a polished online store, publish your products and services, and
					let local customers discover, order, and book from one modern
					storefront.
				</motion.p>

				<motion.div
					className='landing-hero__actions'
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.65, delay: 0.24 }}>
					<a className='landing-button landing-hero__cta' href='/signup'>
						Start Free Today
						<ArrowRight size={18} aria-hidden='true' />
					</a>
					<span>No technical skills. No upfront cost.</span>
				</motion.div>
			</div>

			<motion.div
				className='landing-hero__visual'
				data-parallax='hero'
				initial={{ opacity: 0, scale: 0.96, y: 28 }}
				animate={{ opacity: 1, scale: 1, y: 0 }}
				transition={{ duration: 0.8, delay: 0.22 }}>
				<div className='product-shell'>
					<div className='product-shell__top'>
						<span />
						<span />
						<span />
						<strong>Local Growth OS</strong>
					</div>
					<div className='product-shell__grid'>
						<div className='landing-product-card landing-product-card--wide landing-product-card--hero'>
							<div>
								<p>Today&apos;s AI plan</p>
								<h2>18 bookings projected</h2>
								<span>
									Based on local demand, storefront views, and campaign timing.
								</span>
							</div>
							<Sparkles size={30} aria-hidden='true' />
						</div>
						<div className='landing-product-card landing-product-card--support'>
							<MessageCircle size={24} aria-hidden='true' />
							<h3>Support</h3>
							<p>42 questions answered</p>
						</div>
						<div className='landing-product-card landing-product-card--schedule'>
							<CalendarCheck size={24} aria-hidden='true' />
							<h3>Schedule</h3>
							<p>8 jobs booked</p>
						</div>
						<div className='landing-product-card landing-product-card--wide landing-product-card--dark'>
							<div>
								<h3>Hyperlocal campaign live</h3>
								<p>Targeting Sunnyside, Crescent Heights, and Mission.</p>
							</div>
						</div>
					</div>
				</div>
			</motion.div>
		</section>
	);
}

export default Hero;
